<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';

    import ConfirmationModal from '../../ConfirmationModal.svelte';
    import Modal from '../../Modal.svelte';
    import Button from '../../Button.svelte';
    import {sgettext} from '../../../i18n.js';
    import {handleLocalDevUrl} from '../../../utils.js';
    import {elementVersionEntity} from './elementMediaStore.js';

    export let markupMediaModalId = 'markupMediaModal';
    export let elementSlideId = '';
    export let removeMarkupConfirmationModalId = `removeMarkupConfirmationModal`;
    export let title = sgettext('$$MARKUP_MEDIA$$');
    export let onSave = () => {};
    export let onCancel = () => {};
    export let onMarkupRemovalConfirmed = () => {};
    export let onMarkupRemovalCancelled = () => {jQuery(`#${removeMarkupConfirmationModalId}`).modal('hide');};

    export let sending = false;


    let component = null;

    let src = '';
    $: {
        src = `${PATH_PREFIX}/sw/api/elements_database/elementslides/${elementSlideId}/markup_element_media/`
    }
    function onSaveClick(){
        component.contentWindow.saveCanvasJson();
        onSave(component, elementSlideId, $elementVersionEntity);
    }

    function onMarkupRemovalConfirmedClick() {
        onMarkupRemovalConfirmed(component, elementSlideId, $elementVersionEntity);
        jQuery(`#${removeMarkupConfirmationModalId}`).modal('hide');
    }
</script>

<style>
    .markup-canvas-container {
        display: flex;
        width: 100%;
        height: 800px;
        flex-direction: column;
    }

    .markup-canvas-container iframe {
        height: 100%;
    }
</style>

<Modal
    id={markupMediaModalId}
    title={sgettext(title)}
    extraLarge={true}
    backdrop={'static'}>

    <div slot="body" class="markup-canvas-container">
        <slot name="message">
        {#if elementSlideId}
            <iframe
                bind:this={component}
                width="99.6%"
                frameborder="0"
                {src}
                title={sgettext('$$MARKUP$$')} />
        {/if}
        </slot>

    </div>

    <div slot="footer">
        <Button 
            on:click={onSaveClick}
            disabled={sending}
            name={sgettext('$$SAVE$$')}
            {sending}
        />
        <Button 
            on:click={onCancel}
            name={sgettext('$$CANCEL$$')}
            type="secondary"
        />
    </div>
</Modal>

<ConfirmationModal
    id={removeMarkupConfirmationModalId}
    title="{sgettext('$$DELETE_CONFIRMATION$$')}"
    onYes={onMarkupRemovalConfirmedClick}
    onNo={onMarkupRemovalCancelled}>
    <div slot="message">
        <p>{sgettext('$$SURE_WANT_REMOVE_MARKUP_1$$')}</p>
    </div>
</ConfirmationModal>